/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_Event_Group_Type_Audio_DescriptionInputs */

const en_edit_event_group_type_audio_description = /** @type {(inputs: Edit_Event_Group_Type_Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio Description`)
};

const fr_edit_event_group_type_audio_description = /** @type {(inputs: Edit_Event_Group_Type_Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description audio`)
};

const de_edit_event_group_type_audio_description = /** @type {(inputs: Edit_Event_Group_Type_Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audiobeschreibung`)
};

const it_edit_event_group_type_audio_description = /** @type {(inputs: Edit_Event_Group_Type_Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrizione audio`)
};

const ru_edit_event_group_type_audio_description = /** @type {(inputs: Edit_Event_Group_Type_Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Аудиоописание`)
};

const es_edit_event_group_type_audio_description = /** @type {(inputs: Edit_Event_Group_Type_Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descripción de audio`)
};

const zh_cn2_edit_event_group_type_audio_description = /** @type {(inputs: Edit_Event_Group_Type_Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音频描述`)
};

const ja_edit_event_group_type_audio_description = /** @type {(inputs: Edit_Event_Group_Type_Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーディオ説明`)
};

const hi_edit_event_group_type_audio_description = /** @type {(inputs: Edit_Event_Group_Type_Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो विवरण`)
};

const pt_pt2_edit_event_group_type_audio_description = /** @type {(inputs: Edit_Event_Group_Type_Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrição em áudio`)
};

/**
* | output |
* | --- |
* | "Audio Description" |
*
* @param {Edit_Event_Group_Type_Audio_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const edit_event_group_type_audio_description = /** @type {((inputs?: Edit_Event_Group_Type_Audio_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_Event_Group_Type_Audio_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_edit_event_group_type_audio_description(inputs)
	if (locale === "de") return de_edit_event_group_type_audio_description(inputs)
	if (locale === "it") return it_edit_event_group_type_audio_description(inputs)
	if (locale === "ru") return ru_edit_event_group_type_audio_description(inputs)
	if (locale === "es") return es_edit_event_group_type_audio_description(inputs)
	if (locale === "zh-CN") return zh_cn2_edit_event_group_type_audio_description(inputs)
	if (locale === "ja") return ja_edit_event_group_type_audio_description(inputs)
	if (locale === "hi") return hi_edit_event_group_type_audio_description(inputs)
	if (locale === "pt-PT") return pt_pt2_edit_event_group_type_audio_description(inputs)
	return en_edit_event_group_type_audio_description(inputs)
});